import React, { useMemo } from 'react';
// ----------------------------------------------------------------------------------------------------
import CentersIndex from '../pages/centers';
import CenterDetails from '../pages/centers/details/[id]';
import CreateNewCenter from '../pages/centers/details/create';
//----
import TrainersIndex from '../pages/trainers';
import TrainerDetails from '../pages/trainers/details/[id]';
import CreateNewTrainer from '../pages/trainers/details/create';
//----
import ExercisesIndex from '../pages/exercises';
import CreateNewExercise from '../pages/exercises/details/create';
//----
import NoticesIndex from '../pages/notices';
import NoticeDetails from '../pages/notices/details/[id]';
import CreateNewNotice from '../pages/notices/details/create';
//----
import AdminsIndex from '../pages/admins';
//----

import PlayIndex from '../pages/play';

// images
import menuSection from '../assets/images/menu_section.png';
import menuSetting from '../assets/images/menu_setting.png';

import icoCenter from '../assets/images/ico_center.png';
import icoTrainer from '../assets/images/ico_trainer.png';
import icoExercise from '../assets/images/ico_exercise.png';
import icoNotice from '../assets/images/ico_notice.png';
import icoAdmin from '../assets/images/ico_admin.png';

import icoCenterW from '../assets/images/ico_center_white.png';
import icoTrainerW from '../assets/images/ico_trainer_white.png';
import icoExerciseW from '../assets/images/ico_exercise_white.png';
import icoNoticeW from '../assets/images/ico_notice_white.png';
import icoAdminW from '../assets/images/ico_admin_white.png';
// ----------------------------------------------------------------------------------------------------
// side menus // default icon
// import { StarOutlined } from '@ant-design/icons';
const pages = [
  // menu
  {
    // idx: 1,
    type: 'section',
    icon: menuSection,
    // 2뎁스 메뉴 그룹핑
    // group: '기사 관리',
    // isSubMenu :false,  //
  },
  //----------------------------------------------------------------------------------------------------
  {
    // idx: 2,
    type: 'menu',
    title: '센터',
    path: '/centers',
    icon: (checked) =>
      checked ? (
        <img width={24} height={24} src={icoCenterW} />
      ) : (
        <img width={24} height={24} src={icoCenter} />
      ), //<StarOutlined />,
    onClick: (props) => {
      // console.log('--->first');
      props.navigate(props.path);
    },
    style: { width: '24rem' },
    // avatar
    right: null, // <StarOutlined />,
    screen: CentersIndex,
  },
  {
    type: 'page',
    title: '센터상세보기',
    path: '/centers/details/:id',
    screen: CenterDetails,
  },
  {
    type: 'page',
    title: '센터등록하기',
    path: '/centers/new',
    screen: CreateNewCenter,
  },
  //----------------------------------------------------------------------------------------------------
  {
    type: 'menu',
    title: '트레이너',
    path: '/trainers',
    icon: (checked) =>
      checked ? (
        <img width={24} height={24} src={icoTrainerW} />
      ) : (
        <img width={24} height={24} src={icoTrainer} />
      ),
    onClick: (props) => {
      // console.log('--->first');
      props.navigate(props.path);
    },
    style: { width: '24rem' },
    right: null,
    screen: TrainersIndex,
  },
  {
    type: 'page',
    title: '트레이너상세보기',
    path: '/trainers/details/:id',
    screen: TrainerDetails,
  },
  {
    type: 'page',
    title: '트레이너등록하기',
    path: '/trainers/new',
    screen: CreateNewTrainer,
  },
  //----------------------------------------------------------------------------------------------------
  {
    type: 'menu',
    title: '운동',
    path: '/exercises',
    icon: (checked) =>
      checked ? (
        <img width={24} height={24} src={icoExerciseW} />
      ) : (
        <img width={24} height={24} src={icoExercise} />
      ),
    onClick: (props) => {
      // console.log('--->first');
      props.navigate(props.path);
    },
    style: { width: '24rem' },
    right: null,
    screen: ExercisesIndex,
  },
  {
    type: 'page',
    title: '운동 카테고리 및 운동 영상 추가하기',
    path: '/exercises/new',
    screen: CreateNewExercise,
  },
  //----------------------------------------------------------------------------------------------------
  // setting
  {
    type: 'section',
    icon: menuSetting,
  },
  //----------------------------------------------------------------------------------------------------
  {
    type: 'menu',
    title: '공지사항',
    path: '/notices',
    icon: (checked) =>
      checked ? (
        <img width={24} height={24} src={icoNoticeW} />
      ) : (
        <img width={24} height={24} src={icoNotice} />
      ),
    onClick: (props) => {
      // console.log('--->first');
      props.navigate(props.path);
    },
    style: { width: '24rem' },
    right: null,
    screen: NoticesIndex,
  },
  {
    type: 'page',
    title: '공지사항 상세보기',
    path: '/notices/details/:id',
    screen: NoticeDetails,
  },
  {
    type: 'page',
    title: '공지사항 추가하기',
    path: '/notices/new',
    screen: CreateNewNotice,
  },
  //----------------------------------------------------------------------------------------------------
  {
    type: 'menu',
    title: '최고관리자',
    path: '/admins',
    icon: (checked) =>
      checked ? (
        <img width={24} height={24} src={icoAdminW} />
      ) : (
        <img width={24} height={24} src={icoAdmin} />
      ),
    onClick: (props) => {
      // console.log('--->first');
      props.navigate(props.path);
    },
    style: { width: '24rem' },
    right: null,
    screen: AdminsIndex,
  },
  //----------------------------------------------------------------------------------------------------
];

/**
 * 좌측 메뉴 컴포넌트 route  설정
 * @author
 * */
export const useRoutes = () => {
  const routes = useMemo(
    () =>
      pages
        // rouete 대상
        .filter((v) => v.type == 'menu' || v.type == 'page')
        .reduce((output, page) => {
          const path = page.path.substring(1);
          const parentPath = '/' + path.substring(0, path.indexOf('/'));
          const parentIndex =
            path.indexOf('/') >= 0
              ? output.findIndex((v) => v.path === parentPath)
              : undefined;
          if (parentIndex === undefined) {
            output.push({
              path: page.path,
              title: page.title,
              icon: page.icon,
            });
          }
          /*
          // sub menu가 있는 경우
          else {
            if (!output[parentIndex].children)
              output[parentIndex].children = [];
            output[parentIndex].children.push({
              path: page.path,
              title: page.title,
              group: page.group,
            });
          }
          */
          return output;
        }, []),
    [pages]
  );

  return { routes, pages };
};

export default useRoutes;
